import React from 'react'
import PropTypes from 'prop-types'

const displayNames = {
  true: 'Condition.True',
  false: 'Condition.False',
  if: 'Condition.If',
  else: 'Condition.Else',
}

const renderChildren = (children) => (typeof children === 'function' ? children() : children)

export const Condition = ({ condition, children }) => {
  let accCondition = true

  return (
    <React.Fragment>
      {React.Children.map(children, (child) => {
        if (child.type.displayName === displayNames.if) {
          const condition = accCondition && child.props.condition
          accCondition = accCondition && !child.props.condition
          return React.cloneElement(child, { condition })
        } else if (child.type.displayName === displayNames.else) {
          return React.cloneElement(child, { condition: accCondition })
        } else if (
          child.type.displayName === displayNames.true ||
          child.type.displayName === displayNames.false
        ) {
          return React.cloneElement(child, {
            condition: child.props.condition !== undefined ? child.props.condition : condition,
          })
        } else {
          return child
        }
      })}
    </React.Fragment>
  )
}

Condition.propTypes = {
  condition: PropTypes.any,
  children: PropTypes.any.isRequired,
}

const True = ({ condition, children }) =>
  condition !== undefined && !!condition && renderChildren(children)

True.displayName = displayNames.true

const False = ({ condition, children }) =>
  condition !== undefined && !condition && renderChildren(children)

False.displayName = displayNames.false

// Exactly doing like True but we need another class for checking in the parent Condition component
const If = ({ condition, children }) =>
  condition !== undefined && !!condition && renderChildren(children)

If.displayName = displayNames.if

const Else = ({ condition, children }) =>
  condition !== undefined && !!condition && renderChildren(children)

Else.displayName = displayNames.else

Condition.True = True
Condition.False = False
Condition.If = If
Condition.ElseIf = If // alias of If
Condition.Else = Else

window.True = True
window.Condition = Condition



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Condition/index.js